import React from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { useVacancyStore } from '../../store/vacancyStore';
import { ReactComponent as TagIcon } from '../../assets/icons/tag-icon.svg';

interface PageHeaderProps {
  title?: string;
  icon?: React.ReactNode;
  isSidebarCollapsed?: boolean;
  onSidebarToggle?: () => void;
  onMenuClick?: () => void;
}

export function PageHeader({
  title,
  icon,
  isSidebarCollapsed = false,
  onSidebarToggle,
  onMenuClick,
}: PageHeaderProps) {
  const { selectedVacancy, selectedVacancyId } = useVacancyStore();

  // Используем название выбранной вакансии, если не передан title и есть выбранная вакансия
  const displayTitle = title || selectedVacancy?.title || 'Вакансии';
  // Показываем метку только если НЕ передан title (страница создания) и есть выбранная вакансия
  const internalTag = !title && selectedVacancyId && selectedVacancy ? (selectedVacancy as any).internalTag : null;

  return (
    <div className="bg-[#F5F6F1] border-b border-[#D9D9D9] px-8 py-4 flex items-center h-[57px] box-border">
      {isSidebarCollapsed && (
        <button
          className="mr-4 hover:opacity-70 transition-opacity"
          onClick={onSidebarToggle}
          aria-label="Развернуть сайдбар"
        >
          <Bars3Icon className="w-4 h-4 text-[var(--text-dark)]" />
        </button>
      )}
      <div className="flex flex-col gap-[2px]">
        <div className="flex items-center gap-2">
          {icon}
          <h1 className="text-[17px] font-inter-tight font-medium tracking-[0.1px] text-[var(--text-dark)]">
            {displayTitle}
          </h1>
        </div>
        {internalTag && (
          <div className="flex items-center gap-1">
            <TagIcon className="w-[10px] h-[10px] flex-shrink-0 text-[#868C98]" />
            <span className="text-[12px] leading-[1.33] text-[#868C98]">
              {internalTag}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
